
export class FiltroProdutoDTO {
  id?: number;
  nome?: string;
  tipoProduto?: string;
  codigoExterno?: string;
  idEsteira?: string | number;
}
